module.exports = __webpack_public_path__ + "static/media/plaid.ad019251.svg";